export default __webpack_public_path__ + "static/media/Aperol_Instructor.18df6c59.png";